import TableVirtualized from '../../components/TableVirtual/TableVirtualized'
import PropTypes from 'prop-types'
import {Box} from '@mui/material'
import {convertDatasetForTable} from './helpers'
import ChartBlankError from './ChartBlankError'
import {StyledBox} from '../TimeSeriesDashboardStyle'

const TimeSeriesTable = ({dataSets, xDates, displayLegend, currentSelections}) => {
  const {data, colName} = convertDatasetForTable(dataSets, xDates, currentSelections)

  return (
    <Box>
      {displayLegend ? (
        <StyledBox isTableContainer={true}>
          <TableVirtualized
            columns={colName}
            data={data}
            dataLoading={false}
            enablePadding={false}
            width={'100%'}
            height={'100%'}
            chartType='timeSeries'
          />
        </StyledBox>
      ) : (
        <ChartBlankError />
      )}
    </Box>
  )
}

TimeSeriesTable.propTypes = {
  dataSets: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      data: PropTypes.arrayOf(PropTypes.number).isRequired
    })
  ).isRequired,
  xDates: PropTypes.arrayOf(PropTypes.string).isRequired,
  displayLegend: PropTypes.bool,
  currentSelections: PropTypes.object
}

export default TimeSeriesTable
